import useLenis from "@/hooks/useLenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { BeforeAfter } from "@/components/BeforeAfter";
import { RecentResults } from "@/components/RecentResults";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { AreasWeCover } from "@/components/AreasWeCover";
import { Reviews } from "@/components/Reviews";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  useLenis();
  return (
    <div className="min-h-screen bg-cream text-ink overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <BeforeAfter />
        <RecentResults />
        <WhyChooseUs />
        <AreasWeCover />
        <Reviews />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
